import {
  type EvidenceTypeEnum,
  getApiTradeV1SiteMaterialsEvidenceListQueryKey,
  useApiTradeV1SiteMaterialsEvidenceListSuspense,
  useQueryClient,
} from 'api';
import { EvidenceUploadButton, useSiteMaterial } from 'features';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ActionRow,
  Button,
  Grid,
  MediaDialog,
  Page,
  PhotoEvidenceItem,
  PhotoEvidenceList,
  Section,
  Typography,
  useBreakpoint,
} from 'ui';

import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const Evidence = ({ evidenceType }: { evidenceType: EvidenceTypeEnum }) => {
  const { isMobile } = useBreakpoint();
  const queryClient = useQueryClient();
  const { data: siteMaterial } = useSiteMaterial();
  const { data } = useApiTradeV1SiteMaterialsEvidenceListSuspense(String(siteMaterial.id), {
    page_size: 10000,
    type: evidenceType,
  });

  const carouselMedia = data.results.map((file) => String(file.file));
  const [selectedImage, setSelectedImage] = useState<string>('');

  const handleSelect = (src: string) => {
    const relatedMedia = data.results.find((photo) => photo.file === src || photo.preview === src);
    setSelectedImage(relatedMedia?.file || '');
  };

  if (!data) {
    return <Typography>Material not found</Typography>;
  }

  return (
    <>
      <Page>
        <Page.Title title="Manage Evidence" />
        <Page.Divider />
        <Grid container>
          <Grid item xs={12} md={4}>
            <Section title="Site Details">
              <SiteHeader siteMaterial={siteMaterial} />
            </Section>
          </Grid>
          <Grid item xs={12} md={8}>
            <Section
              title="Evidence"
              action={
                <ActionRow>
                  <Button size="large" fullWidth variant="secondary" component={Link} to="edit">
                    Edit
                  </Button>
                  <EvidenceUploadButton
                    evidenceType={evidenceType}
                    parentId={String(siteMaterial.id)}
                    mode={'site-material'}
                    isOnline={true}
                    onSuccess={() => {
                      queryClient.invalidateQueries({
                        queryKey: getApiTradeV1SiteMaterialsEvidenceListQueryKey(String(siteMaterial.id)),
                      });
                    }}
                  />
                </ActionRow>
              }
            >
              <PhotoEvidenceList
                openOnClick
                slotProps={{
                  imageList: {
                    cols: isMobile ? 3 : 5,
                  },
                }}
                evidencePhotos={data.results.map(({ file, preview }) => ({
                  src: (preview || file) ?? '',
                }))}
                handleClick={(photo: PhotoEvidenceItem) => handleSelect(photo.src)}
              />
            </Section>
          </Grid>
        </Grid>
      </Page>

      <MediaDialog
        open={Boolean(selectedImage)}
        selectedMedium={selectedImage}
        onClose={() => setSelectedImage('')}
        media={carouselMedia}
        handleNavigate={setSelectedImage}
      />
    </>
  );
};
